/**
 * 重要品牌（地圖放大）— 對齊 scripts/lib/poi-mapper.js `BRAND_CONFIG`
 * 圖示：/img/poi-brands/{id}.svg（合計 ~10KB；URL 快取，不按點數乘載）
 * 圖例固定另產、不進 POI圖匯出。
 */

/** @typedef {{ id: string, label: string, keywords: string[], size: number, iconUrl: string }} ImportantBrand */

const BRAND_ICON_REV = '17.0.788';

function brandIconUrl(id) {
    return `/img/poi-brands/${id}.svg?v=${BRAND_ICON_REV}`;
}

/** @type {ImportantBrand[]} */
export const IMPORTANT_BRANDS = [
    { id: '711', label: '7-Eleven', keywords: ['7-Eleven', '7-11', 'Seven Eleven', '統一超商'], size: 38 },
    { id: 'FAMILYMART', label: '全家', keywords: ['FamilyMart', '全家'], size: 38 },
    { id: 'HILIFE', label: '萊爾富', keywords: ['萊爾富', 'Hi-Life', 'HiLife'], size: 36 },
    { id: 'OKMART', label: 'OK超商', keywords: ['OK Mart', 'OK超商', 'OKmart'], size: 36 },
    { id: 'PXMART', label: '全聯', keywords: ['全聯', 'PX Mart', 'PXMart'], size: 38 },
    { id: 'CARREFOUR', label: '萬家福', keywords: ['萬家福', '樂家康', '家樂福', 'Carrefour', 'Prosperity Plaza', 'Uni-Prosperity'], size: 38 },
    { id: 'COSTCO', label: '好市多', keywords: ['Costco', '好市多'], size: 40 },
    { id: 'MCDONALDS', label: '麥當勞', keywords: ['McDonald', '麥當勞'], size: 38 },
    { id: 'KFC', label: '肯德基', keywords: ['KFC', '肯德基'], size: 36 },
    { id: 'PIZZAHUT', label: '必勝客', keywords: ['必勝客', 'Pizza Hut', 'PizzaHut'], size: 36 },
    { id: 'STARBUCKS', label: '星巴克', keywords: ['Starbucks', '星巴克'], size: 38 },
    { id: 'LOUISA', label: '路易莎', keywords: ['路易莎', 'Louisa'], size: 36 },
    { id: '85C', label: '85度C', keywords: ['85度C', '85C', '85℃'], size: 36 },
    { id: '50LAN', label: '50嵐', keywords: ['50嵐', '50 Lan', '50LAN'], size: 34 },
    { id: 'COCO', label: 'CoCo都可', keywords: ['CoCo', '都可'], size: 34 },
    { id: 'COSMED', label: '康是美', keywords: ['康是美', 'Cosmed'], size: 36 },
    { id: 'UNIQLO', label: 'UNIQLO', keywords: ['UNIQLO', '優衣庫'], size: 36 },
    { id: 'NET', label: 'NET', keywords: ['NET'], size: 34 },
    { id: 'ESLITE', label: '誠品', keywords: ['誠品', 'Eslite'], size: 36 },
    { id: 'YOUBIKE', label: 'YouBike', keywords: ['YouBike', 'U-Bike', 'Ubike'], size: 34 },
    { id: 'MRT', label: '捷運站', keywords: ['捷運站', '捷運出口', 'MRT'], size: 34 }
].map((b) => ({ ...b, iconUrl: brandIconUrl(b.id) }));

const BY_ID = new Map(IMPORTANT_BRANDS.map((b) => [b.id, b]));

function haystack(properties = {}) {
    return [
        properties.h_brand_id,
        properties.h_brand_name,
        properties.h_name,
        properties.name,
        properties.brand
    ]
        .filter(Boolean)
        .join(' ');
}

/**
 * @param {object} properties
 * @returns {ImportantBrand|null}
 */
export function resolveImportantBrand(properties = {}) {
    const id = String(properties.h_brand_id || '').trim().toUpperCase();
    if (id && BY_ID.has(id)) return BY_ID.get(id);

    const text = haystack(properties);
    if (!text) return null;
    const lower = text.toLowerCase();
    for (const brand of IMPORTANT_BRANDS) {
        for (const kw of brand.keywords) {
            if (text.includes(kw) || lower.includes(String(kw).toLowerCase())) {
                return brand;
            }
        }
    }
    return null;
}

export function importantBrandIds() {
    return IMPORTANT_BRANDS.map((b) => b.id);
}

/** 預載全部品牌 SVG（一次；後續標記共用快取） */
export function preloadImportantBrandIcons() {
    if (typeof document === 'undefined') return;
    for (const brand of IMPORTANT_BRANDS) {
        const img = new Image();
        img.decoding = 'async';
        img.src = brand.iconUrl;
    }
}
